import { Injectable } from '@angular/core';
import {
  GetPackageStatusRequest, GetPackageStatusResponse,
  CheckTokenExpiryRequest,
  GetBusinessSettingsRequest, GetBusinessSettingsResponse,
  GetUserProfileRequest, GetUserProfileResponse,
  GetBusinessOnboardingDetailsResponse,
  GetBusinessIntegrationSettingsRequest, GetBusinessIntegrationSettingsResponse,
  GetFacebookAdAccountStatusRequest, GetFacebookAdAccountStatusResponse,
  GetMetaIntegrationStatusRequest, GetMetaIntegrationStatusResponse,
  GetIsCouponFeatureEnabledResponse,
  GetIsCouponFeatureEnabledRequest,
} from '../grpc-models/Common_pb';
import { CommonProtoService } from '../grpc-services/Common_pb_service';
import { GrpcService } from './grpc.service';
import { TokenService } from './token.service';
import { OnboardingService } from './onboarding.service';
import { AuthSessionService } from './auth-session.service';
import { LoaderKeys } from '../constants/constants';

/**
 * Lean gRPC service for the app-bootstrap aggregate (Common.proto).
 *
 * It exposes only the handful of calls app.component needs at boot, backed by the
 * small `Common_pb` model instead of the large per-domain protos. Using it in the
 * eager path keeps those big protos (e.g. Subscription_pb) out of the initial
 * main.js bundle — they now load only in their own lazy feature routes.
 */
@Injectable({ providedIn: 'root' })
export class AppBootstrapService {
  constructor(
    private grpcService: GrpcService,
    private tokenService: TokenService,
    private onboardingService: OnboardingService,
    private authSessionService: AuthSessionService,
  ) {}

  getPackageStatus(): Promise<GetPackageStatusResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      new GetPackageStatusRequest(),
      CommonProtoService.GetPackageStatus,
      this.tokenService.getMetaData(),
    );
  }

  // Returns `any` to match the original useraccount.service contract — app.component
  // reads extra (impersonation-token-flow) fields off this result, so keep it loosely typed.

   public checkTokenExpiry() {
      let request = new CheckTokenExpiryRequest();
      request.setToken(this.authSessionService.getToken() + '')
      return this.grpcService.grpcUnaryService(request, CommonProtoService.CheckTokenExpiry, undefined, false, undefined);
  }
    
  getBusinessSettings(): Promise<GetBusinessSettingsResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      new GetBusinessSettingsRequest(),
      CommonProtoService.GetBusinessSettings,
      this.tokenService.getMetaData(),
    );
  }

  getUserProfile(): Promise<GetUserProfileResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      new GetUserProfileRequest(),
      CommonProtoService.GetUserProfile,
      this.tokenService.getMetaData(), false, LoaderKeys.GetUserProfile,
    );
  }

  getBusinessOnboardingDetails(): Promise<GetBusinessOnboardingDetailsResponse.AsObject> {
    return this.onboardingService.getBusinessOnboardingDetails() as unknown as Promise<GetBusinessOnboardingDetailsResponse.AsObject>;
  }

  getBusinessIntegrationSettings(): Promise<GetBusinessIntegrationSettingsResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      new GetBusinessIntegrationSettingsRequest(),
      CommonProtoService.GetBusinessIntegrationSettings,
      this.tokenService.getMetaData(),
    );
  }

  getFacebookAdAccountStatus(): Promise<GetFacebookAdAccountStatusResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      new GetFacebookAdAccountStatusRequest(),
      CommonProtoService.GetFacebookAdAccountStatus,
      this.tokenService.getMetaData(), true, LoaderKeys.GetFacebookAdAccountStatusKey,
    );
  }

  getMetaIntegrationStatus(): Promise<GetMetaIntegrationStatusResponse.AsObject> {
    return this.grpcService.grpcUnaryService(
      new GetMetaIntegrationStatusRequest(),
      CommonProtoService.GetMetaIntegrationStatus,
      this.tokenService.getMetaData(), true,
    );
  }

  

    getIsCouponFeatureEnabled(): Promise<GetIsCouponFeatureEnabledResponse.AsObject>{
      return this.grpcService.grpcUnaryService(
        new GetIsCouponFeatureEnabledRequest(),
        CommonProtoService.GetIsCouponFeatureEnabled,
        undefined, true
      )
    }
    
}
